import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment.local';
import {ITaxInformationRequest} from './models/i-tax-information-request';
import {Observable} from 'rxjs';
import {ITaxInformationResponse} from './models/i-tax-information-response';

@Injectable({
  providedIn: 'root',
})
export class TaxInformationApi {
  http: HttpClient = inject(HttpClient);

  readonly TAX_INFORMATION_URL: string = `${environment.apiUrl}/api/tax-information`;

  create(dto: ITaxInformationRequest): Observable<ITaxInformationResponse> {
    return this.http.post<ITaxInformationResponse>(this.TAX_INFORMATION_URL, dto);
  }

  update(dto: ITaxInformationRequest): Observable<ITaxInformationResponse> {
    return this.http.put<ITaxInformationResponse>(this.TAX_INFORMATION_URL, dto);
  }
}
